import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { ENUM_API } from "./apiRoutes";
import axiosAuth from "@/services/axiosAuth";

interface UseGetEnumDropdownProps {
  enumName: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">
}

const getEnumDropdown = async (enumName: string) =>
  await axiosAuth.get(`${ENUM_API}/${enumName}/dropdown`);

const useGetEnumDropdown = ({enumName, queryParams}: UseGetEnumDropdownProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["enum"],
    queryFn: () => getEnumDropdown(enumName),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!enumName && (queryParams?.enabled ?? true),
  });
};

export default useGetEnumDropdown;
